import { render, staticRenderFns } from "./MissingInfo.vue?vue&type=template&id=654b968b&scoped=true&lang=pug&"
import script from "./MissingInfo.vue?vue&type=script&lang=js&"
export * from "./MissingInfo.vue?vue&type=script&lang=js&"
import style0 from "./MissingInfo.vue?vue&type=style&index=0&id=654b968b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b968b",
  null
  
)

export default component.exports